export default function Loading() {
  return (
    <div className="relative flex items-center justify-center w-15 h-15">
      <img src="/img/icon/loading.svg" className="size-12 loading-spinner" />

      <div className="absolute top-0 left-0 bottom-0 right-0 z-10 flex items-center justify-center p-[25%]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="29"
          height="24"
          viewBox="0 0 29 24"
          fill="none"
        >
          <path
            d="M20.6161 24L21.9649 21.6611L16.7007 12.5306L16.2291 13.3485C15.6858 14.2908 15.6858 15.4512 16.2292 16.3935L20.6161 24Z"
            fill="#FAFBFF"
          />
          <path
            d="M28.5791 10.1905L27.2303 12.5294L16.7002 12.5304L17.1703 11.7152C17.7146 10.7716 18.7211 10.1902 19.8104 10.1902L28.5791 10.1905Z"
            fill="#FAFBFF"
          />
          <path
            d="M19.7461 0L22.4436 4.02238e-07L18.0588 7.60419C17.5146 8.54788 16.5081 9.12937 15.4188 9.12943L14.4801 9.12947L19.7461 0Z"
            fill="#FAFBFF"
          />
          <path
            d="M9.21422 0.000566686L6.5167 0.000566252L10.9015 7.60476C11.4457 8.54845 12.4521 9.12994 13.5415 9.12999L14.4802 9.13004L9.21422 0.000566686Z"
            fill="#FAFBFF"
          />
          <path
            d="M2.11829 12.4731L0.769531 10.1342L9.53814 10.1339C10.6275 10.1339 11.634 10.7153 12.1783 11.6589L12.6481 12.4736L12.6484 12.4742L13.1197 13.2915C13.663 14.2338 13.663 15.3942 13.1196 16.3364L8.7327 23.9429L7.38394 21.6041L12.6477 12.4742L2.11829 12.4731Z"
            fill="#FAFBFF"
          />
        </svg>
      </div>
    </div>
  );
}
